import { Component, OnInit, Input } from '@angular/core'
import { FDLMService } from '../../services/FDLM.Service';//SE IMPORTA EL SERVICIO
import { Observable } from 'rxjs';
import { InfoSeparador } from '../../Interfaces';

@Component({
  selector: "cabezote",
  templateUrl:"./cabezote.component.html"
})
export class cabezote implements OnInit{
  constructor(private FDLMService: FDLMService) {

  }

  //PARAMETROS DE ENTRADA AL COMPONENTE
  @Input() varNumSolicitud: string;

  //CAMPOS PRIVADOS
  public isLoaded: boolean= false;
  public lstInfoSeparador: Observable<InfoSeparador[]>;

  //LO EJECUTA CUANDO INICIA LA PAGINA
  public ngOnInit() {
  //SE ENVIA A CARGAR INFORMACION DE CABEZOTE
    this.CargarInfoCabezote();
  }

  public CargarInfoCabezote() {

    this.lstInfoSeparador = this.FDLMService.GetSeparadorXNumSolicitud(this.varNumSolicitud, this.FDLMService.usuarioData.idEmpSede);
    this.isLoaded = true;
  }
}
